import { IPurchasingGroupAssignableCompanyCodeDto } from '../types/purchasing-group-assignable-company-code.dto';
import { IPurchasingGroupDetailDto } from '../types/purchasing-group-detail.dto';

export class PurchasingGroupDetail {
    public readonly id: string;
    public readonly code: string;
    public readonly name: string;
    public readonly description: string | null;
    public readonly active: boolean;
    public readonly assignedCompanyCodes: readonly IPurchasingGroupAssignableCompanyCodeDto[];

    constructor(dto: IPurchasingGroupDetailDto) {
        this.id = dto.id;
        this.code = dto.code;
        this.name = dto.name;
        this.description = dto.description;
        this.active = dto.active;
        this.assignedCompanyCodes = dto.assignedCompanyCodes ?? [];
    }
}
